import type { MarkdownSyncMetadata } from '../../context/TimelineContext'
import type { ChecklistItem as BoardChecklistItem } from '../../types/schema'
import { nodesToMarkdownPayload } from '../../utils/markdownSync'
import { Button } from '../Common/Button'
import { TextInput } from '../Common'

type MarkdownSyncStatusProps = {
  metadata: MarkdownSyncMetadata
  nodes: BoardChecklistItem[]
  onLinkRepo: (repoPath: string) => void
  onSimulateInboundSync: (markdownPayload: string) => void
}

export const MarkdownSyncStatus = ({
  metadata,
  nodes,
  onLinkRepo,
  onSimulateInboundSync,
}: MarkdownSyncStatusProps) => {
  if (!metadata.repoPath) {
    return (
      <form
        className="markdownSyncAnchorForm"
        onSubmit={(event) => {
          event.preventDefault()
          const formData = new FormData(event.currentTarget)
          const repoPath = String(formData.get('repoPath') ?? '').trim()
          if (repoPath) onLinkRepo(repoPath)
        }}
      >
        <label>
          <span>Anchor Markdown .md Repository Target</span>
          <TextInput
            name="repoPath"
            placeholder="github://workspace/docs/PLAN.md"
            maxLength={120}
          />
        </label>
        <Button variant="primary" size="sm" type="submit">Anchor</Button>
      </form>
    )
  }

  const markdownPreview = nodesToMarkdownPayload(nodes)

  return (
    <div className="markdownSyncRibbon">
      <div>
        <span>md-sync</span>
        <strong>{metadata.repoPath}</strong>
        <small>{metadata.isSyncingInProgress ? 'syncing' : metadata.lastSyncedCommit ?? 'watching'}</small>
      </div>
      <Button variant="tertiary" size="sm" onClick={() => onLinkRepo(metadata.repoPath ?? 'github://workspace/docs/PLAN.md')}>
        Relink
      </Button>
      <Button
        variant="tertiary"
        size="sm"
        onClick={() => {
          const simulatedPayload = markdownPreview
            .split('\n')
            .map((line, index) => index === 0 ? line.replace('[ ]', '[x]') : line)
            .join('\n')
          onSimulateInboundSync(simulatedPayload)
        }}
      >
        Simulate Webhook
      </Button>
    </div>
  )
}
